import React from "react";
import AppRoutes from "AppRoutes";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { UserTypeEnum } from "common/enums/UserType.enum";
import HeaderTopSeller from "components/seller/HeaderTopSeller";
import HeaderTopBuyer from "components/buyer/HeaderTopBuyer";
import SidebarSeller from "components/seller/SidebarSeller";
import SidebarBuyer from "components/buyer/SidebarBuyer";
import MenuBottomMobileSeller from "components/seller/MenuBottomMobileSeller";
import MenuBottomMobileBuyer from "components/buyer/MenuBottomMobileBuyer";
import SidebarAdmin from "components/admin/SidebarAdmin";
import HeaderTopAdmin from "components/admin/HeaderTopAdmin";
import MenuBottomMobileAdmin from "components/admin/MenuBottomMobileAdmin";
const Layout = () => {
  const { userData } = useSelector((state: RootState) => state.auth);
  return (
    <>
      <div className="md:flex min-h-[1024px] items-start">
        {/*Slide Menu*/}
        {userData?.type === UserTypeEnum.COMPANY_SELLER ? (
          <SidebarSeller />
        ) : (
          ""
        )}
        {userData?.type === UserTypeEnum.COMPANY_BUYER ? <SidebarBuyer /> : ""}
        {userData?.type === UserTypeEnum.ADMIN ? <SidebarAdmin /> : ""}
        {/*Main*/}
        <div className="flex min-h-[1024px] min-w-0 pl-[5px] pr-[5px] py-[5px] md:pl-[240px] md:pr-[10px] md:py-[10px] flex-col items-start flex-[1_0_0] bg-primary">
          <div className="relative flex min-h-[1004px] min-w-0 flex-col items-start self-stretch rounded-[12px] bg-white">
            {/*Header*/}
            {userData?.type === UserTypeEnum.COMPANY_SELLER ? (
              <HeaderTopSeller />
            ) : (
              ""
            )}
            {userData?.type === UserTypeEnum.COMPANY_BUYER ? (
              <HeaderTopBuyer />
            ) : (
              ""
            )}
            {userData?.type === UserTypeEnum.ADMIN ? <HeaderTopAdmin /> : ""}
            {/*Body*/}
            <AppRoutes />
            {/*Fix Menu (Mobile)*/}
            {userData?.type === UserTypeEnum.COMPANY_SELLER ? (
              <MenuBottomMobileSeller />
            ) : (
              ""
            )}
            {userData?.type === UserTypeEnum.COMPANY_BUYER ? (
              <MenuBottomMobileBuyer />
            ) : (
              ""
            )}
            {userData?.type === UserTypeEnum.ADMIN ? (
              <MenuBottomMobileAdmin />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
